import * as Yup from "yup";

export const MakeTransferValidation = Yup.object().shape({
  transferAmount: Yup.number()
    .required("Transfer amount is required")
    .typeError("Transfer Fee must be a number")
    .positive("Transfer amount must be a positive number")
    .min(1, "Transfer amount must be at least 1"),

  selectedBank: Yup.string().required("Bank selection is required"),

  accountNumber: Yup.string()
    .required("Account number is required")
    .matches(/^\d{10}$/, "Account number must be exactly 10 digits"),
});

export type MakeTransferForm = Yup.InferType<typeof MakeTransferValidation>;
